module.exports = __webpack_public_path__ + "static/media/mosca_burns_durnin_hodgens.e1328f54.gif";